import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportMeritService } from '../../service/report-merit.service';

@Component({
  selector: 'app-configure-sgfi-payment',
  templateUrl: './configure-sgfi-payment.component.html',
  styleUrls: ['./configure-sgfi-payment.component.css']
})
export class ConfigureSgfiPaymentComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  /** Which field's help text is on screen; help is hidden until asked for. */
  openHelp = '';
  sgfiAmountForm: FormGroup;
  loading = true;
  saving = false;
  error = '';
  success = '';
  loaded = false;

  constructor(private fb: FormBuilder, private meritService: ReportMeritService) {}

  ngOnInit() {
    this.sgfiAmountForm = this.fb.group({
      id: [''],
      amount: ['', [Validators.required, Validators.min(0.01),
        Validators.max(99999999.99), Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      reviewDays: ['', [Validators.min(1), Validators.max(999), Validators.pattern(/^\d*$/)]]
    });
    this.getAmountData();
  }

  getAmountData() {
    this.loading = true;
    this.loaded = false;
    this.error = '';
    this.meritService.getAmountData().pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        this.loading = false;
        if (!Array.isArray(response) || !response.length) {
          this.error = 'No SGFI fee configuration was found. Contact support to set it up.';
          return;
        }
        this.sgfiAmountForm.setValue({ id: response[0].id, amount: response[0].amount, reviewDays: response[0].reviewDays || '' });
        this.sgfiAmountForm.markAsPristine();
        this.loaded = true;
      },
      () => {
        this.loading = false;
        this.error = 'Could not load the SGFI fee. Please try again.';
      }
    );
  }

  onSubmit() {
    if (!this.loaded || this.saving || this.sgfiAmountForm.invalid) return;
    const id = this.sgfiAmountForm.get('id').value;
    const amount = this.sgfiAmountForm.get('amount').value;
    const formData = new FormData();
    formData.append('amount', String(amount));
    formData.append('reviewDays', String(this.sgfiAmountForm.get('reviewDays').value || ''));
    this.error = '';
    this.success = '';
    this.saving = true;
    this.sgfiAmountForm.disable();
    this.meritService.updateSgfilAmount(id, formData).pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.finishSaving();
        if (!res || res.status !== 'success') {
          this.error = 'Could not save the SGFI settings. Please try again.';
          return;
        }
        this.sgfiAmountForm.markAsPristine();
        this.success = 'SGFI settings saved.';
      },
      err => {
        this.finishSaving();
        this.error = (err && err.error && err.error.error) || 'Could not save the SGFI settings. Please try again.';
      }
    );
  }

  toggleHelp(key: string) { this.openHelp = this.openHelp === key ? '' : key; }

  private finishSaving() {
    this.saving = false;
    this.sgfiAmountForm.enable();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
